import React, { useEffect, useState } from 'react';
import { AppRoutes } from './routes';
import { registerHandlers } from './store';
import { AuthProvider } from './context/AuthContext';
import { GlobalProvider } from './context/global';
import LoadingProvider from './context/LoadingContext';
import RoutesProvider from './context/RoutesProvider';
import NotificationProvider from './context/NotificationContext';

// Create a context for the user state
export const UserContext = React.createContext(null);

// Define the top-level component
function Ai2App(store) {
  // Create state for the user
  const [userState, setUserState] = useState({ unsavedData: false });

  // Register the handlers once on mount
  useEffect(() => {
    registerHandlers();
  }, []);

  // Return the app routes, with the user state context
  return (
    <UserContext.Provider
      value={{ userState: userState, setUserState: setUserState }}
    >
      <LoadingProvider>
        <GlobalProvider>
          <AuthProvider>
            <RoutesProvider>
              <NotificationProvider>
                <AppRoutes />
              </NotificationProvider>
            </RoutesProvider>
          </AuthProvider>
        </GlobalProvider>
      </LoadingProvider>
    </UserContext.Provider>
  );
}

export default Ai2App;
